<template class="bg-white">
  <div class="container bg-white">
    <!-- <b-button
      class="btn btn-lg float-right mt-2"
      type="submit"
      variant="primary"
      v-on:click="PrintSection"
    >
      <i class="fa icon-printer"></i> Cetak
    </b-button> -->
    <div id="printSection">
      <table width="100%">
        <tr>
          <td style="width: 100px">
            <img
              src="http://203.115.234.103:1122/V2/SIPPMA_SM/mara.png"
              border="0"
              width="80"
              height="100"
            />
          </td>
          <td>
            <div>
              <h6 class="title">
                <strong>BAHAGIAN PENGANJURAN PELAJARAN MARA</strong>
                <br />
                <strong>TINGKAT 10, IBU PEJABAT MARA,</strong>
                <br />
                <strong>21, JALAN MARA,</strong>
                <br />
                <strong>50609 KUALA LUMPUR</strong>
                <br />
              </h6>
            </div>
          </td>
          <td>
            <div style="float: right">
              <table>
                <tr class="title right">
                  <td>Telefon</td>
                  <td class="right">:03-2613 2000</td>
                </tr>
                <tr class="title">
                  <td>Fax</td>
                  <td class="right">:03-2691 5854</td>
                </tr>
              </table>
            </div>
          </td>
        </tr>
      </table>
      <hr />
      <div class="card-body">
        <div>
          <div class="text-center">
            <h5>
              <strong>BORANG RAYUAN PERMOHONAN</strong>
            </h5>
          </div>
          <table class="wrap-table">
            <tbody>
              <tr>
                <td style="width: 150px" class="sub-title">
                  <span>NAMA PELAJAR</span>
                </td>
                <td class="sub-title">
                  :
                  <span style="text-transform: uppercase">{{ FirstName }}</span>
                </td>
              </tr>
              <tr>
                <td style="width: 150px" class="sub-title">NO. K/P</td>
                <td class="sub-title">: {{ IdentityNo }}</td>
              </tr>
              <tr>
                <td style="width: 150px" class="sub-title">PROGRAM</td>
                <td style="text-transform: uppercase">: {{ ProgrammeName }}</td>
              </tr>
              <tr>
                <td style="width: 150px" class="sub-title">KURSUS</td>
                <td style="text-transform: uppercase">: {{ Course1Name }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style="margin-top: 30px">
          <table>
            <tbody>
              <tr>
                <td>
                  <div>Tujuan/Alasan Rayuan:</div>
                </td>
              </tr>
              <tr>
                <td>
                  <b-form-textarea
                    :rows="9"
                    placeholder="Ulasan.."
                    class="mt-2"
                    vertical
                    v-model="Comment"
                  ></b-form-textarea>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style="margin-top: 30px">
          <table>
            <tbody>
              <tr>
                <td style="width: 200px">
                  <div>Dokumen Sokongan:</div>
                </td>
                <td>
                  <!-- <input
                    type="file"
                    id="fileUpload"
                    ref="myFileUploadAppeal"
                    multiple
                    accept="application/msword, text/plain, application/pdf"
                    @change="onFileChangeAppeal"
                  /> -->
                  <div class="large-12 medium-12 small-12 cell">
                    <label
                      >File <strong>.zip </strong>
                      <input
                        type="file"
                        id="file"
                        ref="file"
                        v-on:change="handleFileUpload()"
                      />
                    </label>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <strong>*Nota</strong>
          <div>
            <span
              >Sila pastikan dokumen-dokumen anda dimasukkan ke dalam
              <strong>folder atas Nama dan No.Kad Pengenalan anda</strong> serta
              <strong>di zipkan (.zip)</strong> sebelum di muat naik dan
              hantar.</span
            >
          </div>
        </div>
        <div style="margin-top: 30px">
          <table>
            <tbody>
              <tr>
                <td>
                  <div>
                    <span class="title"
                      ><h6><strong>Akuan Pelajar</strong></h6></span
                    >
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  Merujuk perkara di atas, saya dengan ini ingin membuat
                  permohonan rayuan untuk program {{ ProgrammeName }} bagi
                  kursus yang di mohon seperti di atas.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <b-row>
          <b-col sm="12" class="float-right mt-2">
            <b-button
              :disabled="Busy == true"
              class="btn btn-lg float-right"
              type="submit"
              variant="primary"
              v-on:click="submitFile"
            >
              <i class="fa fa-dot-circle-o"></i> Hantar
            </b-button>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>


<script>
import DefaultOption from "./DefaultOption";
import _ from "lodash";
import Vue from "vue";
Vue.use(require("vue-moment"));
Vue.use(require("moment"));

export default {
  name: "AppealForm",
  components: {
    DefaultOption,
  },
  data: function () {
    return {
      AppId: 0,
      Error: false,
      Message: "",
      images: [],

      ProgrammeName: "",
      Course1Name: "",
      Comment: "",

      fileUpload: [],
      urlUploadAppeal: null,

      file: "",
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.IdentityNo = "";
      this.FirstName = "";
      this.LastName = "";
      this.ProgramCode = "";
      this.Course1Id = "";
      this.InstitutesName = "";
      await this.GetPersonalDetails();
      await this.GetIntakes();
      await this.GetProposedStudy();
      await this.GetStatusHistory();
    }
  },
  computed: {
    Busy: {
      get: function () {
        return this.$store.getters["common/Busy"];
      },
      set: function (value) {
        this.$store.dispatch("common/updateBusy", value);
      },
    },
    IdentityNo: {
      get: function () {
        return this.$store.getters["appPersonalDetails/IdentityNo"];
      },
      set: function (value) {
        this.$store.dispatch("appPersonalDetails/updateIdentityNo", value);
      },
    },
    FirstName: {
      get: function () {
        return this.$store.getters["appPersonalDetails/FirstName"];
      },
      set: function (value) {
        this.$store.dispatch("appPersonalDetails/updateFirstName", value);
      },
    },
    ProgramCode: {
      get: function () {
        return this.$store.getters["/ProgrameCode"];
      },
      set: function (value) {
        this.$store.dispatch("appPersonalDetails/updateFirstName", value);
      },
    },
    Intake: {
      get: function () {
        return this.$store.getters["appProposedStudy/Intake"];
      },
      set: function (value) {
        this.$store.dispatch("appProposedStudy/updateIntake", value);
      },
    },
    Programme: {
      get: function () {
        let filtered = _.filter(this.Intakes, ["Id", this.Intake]);
        return filtered;
      },
    },
    LevelId: {
      get: function () {
        return this.$store.getters["appProposedStudy/AcademicLevel"];
      },
      set: function (value) {
        this.$store.dispatch("appProposedStudy/updateAcademicLevel", value);
      },
    },
    Course1Id: {
      get: function () {
        return this.$store.getters["appProposedStudy/Course1"];
      },
      set: function (value) {
        this.$store.dispatch("appProposedStudy/updateCourse1", value);
      },
    },
  },
  methods: {
    PrintSection() {
      this.$htmlToPaper("printSection");
    },
    uploadImage(e) {
      let vm = this;
      var selectedFiles = e.target.files;
      for (let i = 0; i < selectedFiles.length; i++) {
        console.log(selectedFiles[i]);
        this.images.push(selectedFiles[i]);
      }

      for (let i = 0; i < this.images.length; i++) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.$refs.image[i].src = reader.result;

          console.log(this.$refs.image[i].src);
        };

        reader.readAsDataURL(this.images[i]);
      }
    },
    submitFiles() {
      let formData = new FormData();

      for (var i = 0; i < this.$refs.file.files.length; i++) {
        let file = this.$refs.file.files[i];
        console.log(file);
        formData.append("files[" + i + "]", file);
      }

      axios
        .post("/fileupload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(function () {})
        .catch(function () {});
    },
    GetPersonalDetails() {
      return this.$API
        .get(this.$PersonalDetails, { withCredentials: true })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200 && this.info != null) {
            this.AppId = this.info.AppId;
            this.IdentityNo = this.info.IdentityNo;
            this.FirstName = this.info.FirstName;
          } else {
            this.Message = "Sila lengkapkan borang pendaftaran";
            console.log(this.info.detail);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Sila lengkapkan borang pendaftaran";
          }
        });
    },
    GetIntakes() {
      return this.$API
        .get(this.$IntakeAll, { withCredentials: true })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200 && this.info != null) {
            this.Intakes = this.info;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    GetProposedStudy() {
      this.$API
        .get(this.$ProposedStudy, { withCredentials: true })
        .then((response) => {
          this.info = response.data;
          if (response.status == 200 && response.data != null) {
            console.log(response);
            this.Intake = this.info.IntakeId;

            let arr = _.filter(this.Intakes, ["Id", this.Intake]);
            this.ProgrammeId = arr[0].ProgramId;
            this.ProgrammeName = arr[0].Name;

            this.InstituteId = this.info.InstituteId;

            if (this.InstituteId == 0)
              this.InstituteName = this.info.InstituteNameOther;
            else this.InstituteName = this.info.InstituteName;
            console.log(
              (this.InstituteNameOther = this.info.InstituteNameOther)
            );

            this.FieldId = this.info.FieldId;

            if (this.FieldId == 9999) this.FieldName = this.info.FieldNameOther;
            else this.FieldName = this.info.FieldName;

            this.Course1Id = this.info.Course1Id;

            if (this.Course1Id == 9999)
              this.Course1Name = this.info.CourseNameOther;
            else this.Course1Name = this.info.Course1Name;

            this.Course1Code = this.info.Course1Code;
          } else {
            console.log(this.info.detail);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
            this.Message = "Sila lengkapkan borang pendaftaran";
          }
        });
    },
    GetStatusHistory() {
      return this.$API
        .get(this.$StatusHistory, { withCredentials: true })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200 && this.info != null) {
            this.StatusHistory = this.info;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    onFileChangeAppeal(e) {
      const file = e.target.files[0];
      this.urlUploadAppeal = URL.createObjectURL(file);
      this.HandleFileInputUpload();
    },
    HandleFileInputUpload() {
      console.log(this.$refs.myFileUploadAppeal.files);
      this.fileUpload = this.$refs.myFileUploadAppeal.files;
      //this.SubmitFileAppeal();
    },
    async SubmitFileAppeal() {
      if (this.fileUpload[0].size > 10485760) {
          alert("Saiz fail terlalu besar. Sila upload semula");
      } else {
        const formData = new FormData();

        formData.append("appId", this.AppId);
        formData.append("comment", this.Comment);
        formData.append("file", this.fileUpload[0]);

        this.$API
          .post(this.$ApplyAppeal, formData, {
            headers: {
              withCredentials: true,
              "Content-Type": "multipart/form-data",
            },
          })
          .then(function (response) {
            if (!response.data) {
              alert("File not uploaded.");
            } else {
              alert("File uploaded successfully.");
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    submitFile() {
      const formData = new FormData();

      formData.append("file", this.file);
      formData.append("appId", this.AppId);
      formData.append("comment", this.Comment);

      return this.$API
        .post(this.$ApplyAppeal, formData, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;
          this.$dialog.alert("Muat Naik Dokumen Berjaya");
          console.log(response);
          if (response.status == 200) {
            console.log("Appeal Details Saved");
          } else console.log("Error Saving");
        })
        .catch((error) => {
          console.log(error);
        });
    },

    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    // SubmitAppeal() {
    //   const formData = new FormData();

    //   formData.append("appId", this.AppId);
    //   formData.append("comment", this.Comment);
    //   formData.append("file", this.FileUpload);

    //   return this.$API
    //     .post(this.$ApplyAppeal, formData, {
    //       withCredentials: true,
    //     })
    //     .then((response) => {
    //       this.info = response.data;
    //       console.log(response);
    //       if (response.status == 200) {
    //         console.log("Appeal Details Saved");
    //       } else console.log("Error Saving");
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // },
  },
};
</script>